import React from 'react';

import { cn } from './cn';

type ComponentWithClassName<P> = React.ComponentType<P & { className?: string }>;

export function styled<P extends { className?: string }>(
  Component: ComponentWithClassName<P>,
  defaultClassName: string
): React.FC<P> {
  const StyledComponent: React.FC<P> = (props) => {
    const mergedClassName = cn(defaultClassName, props.className);
    return React.createElement(Component, { ...props, className: mergedClassName });
  };

  StyledComponent.displayName = `Styled(${Component.displayName || Component.name || 'Component'})`;

  return StyledComponent;
}

export default styled;
